<template>
	<div class="web-pages">
		<div v-for="item in props.page?.grid_items" :key="item" class="my-2">
			<!-- 輪播看板 -->
			<template v-if="item.type == 'carousel_banner'">
				<div ref="carouselRef" :data-ratio="getCarouselRatio(item.data.display_ratio)">
					<el-carousel :autoplay="item.data.carousel_interval > 0" :interval="item.data.carousel_interval * 1000"
						height="100%" :arrow="item.data.banners.length === 1 ? 'never' : 'always'"
						style="border-radius: 5px;" :indicator-position="item.data.banners.length === 1 ? 'none' : ''">
						<!-- 輪播圖 -->
						<el-carousel-item v-for="banner in item.data.banners" :key="banner">
							<template v-if="banner.type == 'image'">
								<a v-if="banner.link" :href="getLink(banner.link)" :target="banner.link.html_target">
									<el-image :src="imgProxy(banner.media.url)" fit="cover"
										:alt="`carousel-${banner.media_id}`" style="width: 100%; height: 100%">
										<template #error>
											<img src="/static/assets/front-end/img/image-place-holder.png"
												style="width: 100%;">
										</template>
									</el-image>
									<!-- <div class="stretchy-image" :style="{ backgroundImage: `url('${banner.media.url}')` }"></div> -->
								</a>
								<el-image v-else :src="imgProxy(banner.media.url)" fit="cover"
									:alt="`carousel-${banner.media_id}`" style="width: 100%; height: 100%">
									<template #error>
										<img src="/static/assets/front-end/img/image-place-holder.png" style="width: 100%;">
									</template>
								</el-image>
								<!-- <div v-else class="stretchy-image" :style="{ backgroundImage: `url('${banner.media.url}')` }"></div> -->
							</template>
							<iframe-video v-else width="100%" height="300px" :src="banner.link.url" autoplay="1"
								allowfullscreen />
						</el-carousel-item>
					</el-carousel>
				</div>
			</template>

			<!-- 簡易看板 -->
			<template v-else-if="item.type == 'image_banner'">
				<el-row :gutter="item.data.remove_padding ? 0 : 4">
					<el-col v-for="banner in item.data.banners" :key="banner"
						:span="getImageColSpan(item.data.banners.length)">
						<a v-if="banner.link" :href="getLink(banner.link)" :target="banner.link.html_target">
							<el-image v-if="item.data.display_ratio == 1" :src="imgProxy(banner.media.url)" :fit="'contain'"
								:alt="getAlt(banner)" style="width: 100%; height: 100%">
								<template #error>
									<img src="/static/assets/front-end/img/image-place-holder.png" style="width: 100%;">
								</template>
							</el-image>
							<RatioImage v-else :src="imgProxy(banner.media.url)" :ratio="getRatio(item.data.display_ratio)"
								:alt="getAlt(banner)" />
						</a>
						<div v-else>
							<el-image v-if="item.data.display_ratio == 1" :src="imgProxy(banner.media.url)"
								:alt="getAlt(banner)" :fit="'contain'" style="width: 100%; height: 100%">
								<template #error>
									<img src="/static/assets/front-end/img/image-place-holder.png" style="width: 100%;">
								</template>
							</el-image>
							<RatioImage v-else :src="imgProxy(banner.media.url)" :alt="getAlt(banner)"
								:ratio="getRatio(item.data.display_ratio)" />
						</div>
					</el-col>
				</el-row>
			</template>

			<!-- 簡易圖片 -->
			<template v-else-if="item.type == 'image'">
				<el-row :gutter="20">
					<el-col>
						<a v-if="item.data.link" :href="getLink(item.data.link)" :target="item.data.link.html_target">
							<el-image :src="imgProxy(item.data.media.url)" :fit="'cover'" alt="media">
								<template #error>
									<img src="/static/assets/front-end/img/image-place-holder.png" style="width: 100%;">
								</template>
							</el-image>
						</a>
						<el-image v-else :src="imgProxy(item.data.media.url)" alt="media" :fit="'cover'">
							<template #error>
								<img src="/static/assets/front-end/img/image-place-holder.png" style="width: 100%;">
							</template>
						</el-image>
					</el-col>
				</el-row>
			</template>

			<!-- 影片 -->
			<template v-else-if="item.type == 'video'">
				<el-row :gutter="20">
					<el-col>
						<iframe-video width="100%" height="315px" :src="item.data.link.url" allowfullscreen />
					</el-col>
				</el-row>
			</template>

			<!-- 文字 -->
			<template v-else-if="item.type == 'text'">
				<el-card :style="{ textAlign: item.data.align }" :header="dt(item.data.title_translations)">
					<div style="white-space: pre-wrap">
						{{ dt(item.data.content_translations) }}
					</div>
				</el-card>
			</template>

			<!-- 主打商品 -->
			<template v-else-if="item.type == 'main_product' && item.data.store_products.length > 0">
				<div class="row flex-between mx-auto">
					<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>
					<div v-if="item.data.keyword" class="view_all d-flex justify-content-center align-items-center">
						<a class="text-capitalize view-all-text"
							style="color:var(--primary_color) !important;margin-right: 8px;"
							:href="'/search?k=' + item.data.keyword">{{ t("global.viewAll") }}
							<i class="czi-arrow-right-circle ml-1 mr-n1"></i>
						</a>
					</div>
				</div>
				<el-row :gutter="10" class="mb-4">
					<el-col v-for="product in item.data.store_products" :key="product" :span="24" :xs="12" :sm="8" :md="6"
						class="mb-2 p-2">
						<ProductItem :product="product" :store-data="props.storeData" />
					</el-col>
				</el-row>
			</template>

			<!-- 熱銷商品 -->
			<template v-else-if="item.type == 'hot_product' && item.data.store_products.length > 0">
				<div class="card mt-2 mb-4">
					<div class="card-body">
						<div class="row d-flex justify-content-between mb-3">
							<div class="h3 text-capitalize">{{ dt(item.data.title_translations) }}</div>
							<div class="view_all d-flex justify-content-center align-items-center">
								<a class="text-capitalize view-all-text"
									style="color:var(--primary_color) !important;margin-right: 8px;"
									:href="`/${routeCategoryPath}?sort=sale_quantity_desc`">{{ t("global.viewAll") }}
									<i class="czi-arrow-right-circle ml-1 mr-n1"></i>
								</a>
							</div>
						</div>

						<el-row :gutter="20">
							<el-col v-for="product in item.data.store_products" :key="product" :span="24" :sm="12" :md="12"
								class="mb-2">
								<ProductItem :product="product" :store-data="props.storeData" item-layout="horizontal" />
							</el-col>
						</el-row>
					</div>
				</div>
			</template>

			<!-- 分類商品 -->
			<template v-else-if="item.type == 'category_product'">
			</template>

			<!-- 圖片分類清單 -->
			<template v-else-if="item.type == 'image_category_list'">
				<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>
				<div class="avatar-slider owl-carousel owl-theme p-2 mb-4" id="categories-slider">
					<div v-for="banner in item.data.category_banners" :key="banner" class="text-center">
						<a :href="getLink(banner.link)" :target="banner.link.html_target">
							<div class="d-flex align-items-center justify-content-center">
								<el-avatar :size="100" :src="imgProxy(banner.media.url, rs = 'fill:100:100:1')"
									:alt="dt(banner.name_translations)" />
							</div>
							<div class="text-truncate-2">
								<span>{{ dt(banner.name_translations) }}</span>
							</div>
						</a>
					</div>
					<a :href="`/${routeCategoryPath}`">
						<el-avatar :size="100"> {{ t("global.viewAll") }} </el-avatar>
					</a>
				</div>
			</template>

			<!-- 網紅列表 -->
			<template v-else-if="item.type == 'kol_fan_pages'">
				<div class="row flex-between mx-auto">
					<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>
				</div>
				<div class="avatar-slider owl-carousel owl-theme p-2 mb-4" id="pages-slider">
					<div v-for="page in item.data.fan_pages" :key="page" class="text-center">
						<a :href="'/fanspage/' + page.id">
							<div>
								<el-avatar v-if="page.picture" :size="100"
									:src="imgProxy(page.picture, rs = 'fill:100:100:1')" :alt="page.name" />
								<el-avatar v-else :size="100"> {{ page.name }} </el-avatar>
							</div>
							<div class="text-truncate-2">
								<span>{{ page.name }}</span>
							</div>
						</a>
					</div>
				</div>
			</template>

			<!-- 網紅開團活動 -->
			<template v-else-if="item.type == 'kol_promotion'">
				<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>

				<div class="row mb-4">
					<div class="col-lg-3 col-md-4 col-sm-4 col-6 mb-3" v-for="prom in item.data.store_promotions"
						:key="prom.id">
						<PromotionItem :promotion="prom" :store-data="props.storeData" />
					</div>
				</div>
			</template>

			<!-- 批發分銷活動 -->
			<template v-else-if="item.type == 'wholesale_promotion' || item.type == 'distribute_promotion'">
				<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>
				<div class="row mb-4">
					<div class="col-lg-3 col-md-4 col-sm-4 col-6 mb-3" v-for="prom in item.data.store_promotions"
						:key="prom.id">
						<PromotionItem :promotion="prom" :store-data="props.storeData" />
					</div>
				</div>
			</template>

			<!-- 批發分銷活動組 -->
			<template v-else-if="item.type == 'wholesale_promotion_group' || item.type == 'distribute_promotion_group'">
				<div class="row flex-between mx-auto">
					<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>
					<div class="view_all d-flex justify-content-center align-items-center">
						<a class="text-capitalize view-all-text"
							style="color:var(--primary_color) !important;margin-right: 8px;"
							:href="'/promotion-groups/' + item.data.store_prom_group_id">{{ t("global.viewAll") }}
							<i class="czi-arrow-right-circle ml-1 mr-n1"></i>
						</a>
					</div>
				</div>
				<div class="row mb-4">
					<div class="col-lg-3 col-md-4 col-sm-4 col-6 mb-3" v-for="prom in item.data.store_promotions"
						:key="prom.id">
						<PromotionItem :promotion="prom" :store-data="props.storeData" />
					</div>
				</div>
			</template>

			<!-- 分銷活動組列表 -->
			<template v-else-if="item.type == 'distribute_promotion_group_list'">
				<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>
				<div class="row mb-4">
					<div class="col-lg-3 col-md-4 col-sm-4 col-6 mb-3" v-for="prom in item.data.store_promotions"
						:key="prom.id">
						<PromotionItem :promotion="prom" :store-data="props.storeData" />
					</div>
				</div>
			</template>

			<!-- 折扣碼 -->
			<template v-else-if="item.type == 'code_promotion'">
				<div class="h3 my-2">{{ dt(item.data.title_translations) }}</div>

				<div class="codes-slider owl-carousel owl-theme p-2 mb-4">
					<div v-for="banner in item.data.promotion_banners" :key="banner.id" class="text-center">
						<a :href="getLink(banner.link)" :target="banner.link.html_target">
							<div>
								<el-avatar v-if="banner.media" shape="square" :size="250"
									:src="imgProxy(banner.media.url, rs = 'fill:250:250:1')"
									:alt="dt(banner.link.ref_object?.title_translations)" />
								<el-avatar v-else shape="square" :size="250"> {{
									dt(banner.link.ref_object?.title_translations) }} </el-avatar>
							</div>
							<div class="text-truncate-2">
								{{ dt(banner.link.ref_object?.title_translations) }}
							</div>
						</a>
						<div class="mt-1">
							<el-button type="primary" class="btn-block"
								:disabled="tempDiscountCodes.includes(banner.link.ref_id)"
								@click="handleCreateDiscountCode(banner)">
								{{ tempDiscountCodes.includes(banner.link.ref_id) ? "已領取" : "領取" }}
							</el-button>
						</div>
					</div>
				</div>
			</template>

			<!-- 按鈕 -->
			<template v-else-if="item.type == 'button_group'">
				<div class="d-flex flex-wrap" :class="`justify-content-${item.data?.align}`">
					<el-link v-for="(button, idx) in item.data.buttons" :key="idx" :style="button.style"
						:href="button.link.url" :target="button.link.html_target" class="p-2 mx-1">
						{{ dt(button.name_translations) }}
					</el-link>
				</div>
			</template>

			<!-- 編輯器 -->
			<template v-else-if="item.type == 'editor'">
				<div v-html="dt(item.data.content_translations)"></div>
			</template>

			<!-- 一頁式活動 -->
			<template v-else-if="isQuickBundle(item?.type)">
				<QuickPromotion :page="item" :store-data="props.storeData" :user-data="props.userData" />
			</template>
		</div>
	</div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from "vue";
import {
  dataTranslations as dt,
  breakpoint,
  checkValidCurrencyStr,
  notificationErrors,
  imgProxy,
} from "../utils";
import { _api_postSubscription } from "../api/index.js";
import { useI18n } from "vue-i18n";
import RatioImage from "./RatioImage.vue";
import IframeVideo from "./IframeVideo.vue";
import ProductItem from "./products/ProductItem.vue";
import PromotionItem from "./promotions/PromotionItem.vue";
import PromotionCategory from "./promotions/PromotionCategory.vue";
import QuickPromotion from "./lites/Promotion.vue";
// @/js/components/lites/Promotion.vue
import { _api_postAccountPromotionCodes } from "../api/index.js";

// 一頁式元件
const QUICK_KEYS = [
	'quick_campaign_promotion',
	'quick_bundle_promotion',
	'quick_kol_promotion',
	'quick_kol_bundle_promotion',
	'quick_distribute_promotion',
	'quick_distribute_promotion_group',
	'quick_distribute_bundle_promotion',
]

const { t, locale } = useI18n();

const props = defineProps({
	page: Object,
	storeData: Object,
	userData: Object,
})

const isMobile = computed(() => breakpoint.value.xs)
const isQuickBundle = (type) => QUICK_KEYS.includes(type)

const AIBWebsiteType = computed(() => window.AIBWebsiteType);
const routeCategoryPath = computed(() => AIBWebsiteType.value === 'saas' ? 'app-market' : 'categories');
const routeProductPath = computed(() => AIBWebsiteType.value === 'saas' ? 'apps' : 'products');

const tempDiscountCodes = ref([]);

const getLink = (link) => {
	if (link.type == 'link') {
		return link.url
	} else if (link.type == 'store_category') {
		return `/${routeCategoryPath.value}/` + link.ref_id
	} else if (link.type == 'store_product') {
		return `/${routeProductPath.value}/` + link.ref_id
	} else if (link.type == 'store_promotion') {
		return '/promotions/' + link.ref_id
	} else if (link.type == 'store_promotion_group') {
		return '/promotion-groups/' + link.ref_id
	} else if (link.type == 'store_promotion_category') {
		return `/${routeCategoryPath}/` + link.ref_id
	}
}
const getRatio = (ratio) => {
	if (ratio === 2) {
		return "2:1"
	} else if (ratio === 3) {
		return "3:1"
	} else if (ratio === 1.778) {
		return "16:9"
	} else if (ratio === 1.333) {
		return "4:3"
	}
	return "1:1"
}
const getCarouselRatio = (ratio) => {
	const percentage = 100 / Number(ratio)
	return `${percentage.toFixed(3)}%`
}
const getImageColSpan = (count) => {
	if (isMobile.value) {
		if (count == 2) {
			return 24
		} else if (count == 4) {
			return 12
		}
	}
	return 24 / count
}

const carouselRef = ref();

const getAlt = (banner) => {
  let str = banner?.media_id;
  try {
    str = dt(banner?.link?.ref_object?.name_translations);
    if (!str) {
      throw str;
    }
  } catch (error) {
    str = dt(banner?.link?.ref_object?.title_translations);
    if (!str) {
      str = `banner-${banner?.media_id}`;
    }
  }
  return str;
};
const setCarouselHeight = () => {
  if (!carouselRef.value) {
    // console.debug("setCarouselHeight: ", carouselRef.value)
    return;
  }
  carouselRef.value.forEach((el) => {
    const ratio = el.dataset["ratio"];
    const item = el.querySelector(".el-carousel__container");
    if (!item || !ratio) {
      console.debug("querySelector fail: ", el);
      return;
    }
    // console.debug("style: ", item.style)

    item.style.paddingTop = ratio;
    // console.debug("paddingTop: ", item.style.paddingTop)
  });
};

const handleCreateDiscountCode = async (banner) => {
  // console.log("handleCreateDiscountCode: ", banner)
  window.fullPageLoading("show");
  try {
    if (
      banner?.link?.ref_object?.codes === undefined ||
      !banner?.link?.ref_object?.codes.length
    ) {
      throw "查無可用折扣碼";
    }

		const params = {
			code: banner?.link?.ref_object?.codes[0],
			action: "get_or_create",
		}

		const resp = await _api_postAccountPromotionCodes(params)
		const eventID = resp?.headers?.["x-request-id"] ? resp?.headers?.["x-request-id"] : null

		aibTrackers.savePromotionCode(banner?.link?.ref_object, eventID)
		gtmTrackers.savePromotionCode(banner?.link?.ref_object, eventID)
		fbqTrackers.savePromotionCode(banner?.link?.ref_object, eventID)
		ttqTrackers.savePromotionCode(banner?.link?.ref_object, eventID)
		gtagTrackers.savePromotionCode(banner?.link?.ref_object, eventID)

		if (resp.data) {
			tempDiscountCodes.value.push(resp.data.store_prom_id)
			swal.fire({
				title: '成功領取折扣碼',
				type: 'success',
				showCancelButton: true,
				confirmButtonColor: 'var(--secondary_color)',
				confirmButtonText: t("carts.continueShopping2"),
				cancelButtonColor: 'var(--primary_color)',
				cancelButtonText: '我的折扣碼',
			}).then((result) => {
				// console.log('result', result);
				if (result.value) {
					// console.log('繼續購物');
				} else if (result.dismiss == "cancel") {
					// console.log('我的折扣碼');
					window.location.href = "/account/promotion-codes";
				}
			})
		}
	} catch (err) {
		if (err?.response?.data) {
			notificationErrors(err.response.data)
		} else {
			console.error("getPromotion Fail: ", err)
		}
	} finally {
		window.fullPageLoading("hide")
	}
}

onMounted(() => {
	setCarouselHeight()

})
$(document).ready(function () {
	$(".owl-carousel").each(function () {
		let margin = 5
		let nav = true
		let dots = false
		let navText = ["<i class='czi-arrow-left'></i>", "<i class='czi-arrow-right'></i>"]
		let responsive = {
			//X-Small
			0: {
				items: 1
			},
			360: {
				items: 1
			},
			375: {
				items: 1
			},
			540: {
				items: 2
			},
			//Small
			576: {
				items: 2
			},
			//Medium
			768: {
				items: 3
			},
			//Large
			992: {
				items: 4
			},
			//Extra large
			1200: {
				items: 5
			},
			//Extra extra large
			1400: {
				items: 5
			}
		}

		if ($(this).hasClass('avatar-slider')) {
			margin = 10
			nav = false
			dots = true
			responsive = {
				//X-Small
				0: {
					items: 2
				},
				360: {
					items: 3
				},
				375: {
					items: 3
				},
				540: {
					items: 4
				},
				//Small
				576: {
					items: 5
				},
				//Medium
				768: {
					items: 7
				},
				//Large
				992: {
					items: 9
				},
				//Extra large
				1200: {
					items: 11
				},
				//Extra extra large
				1400: {
					items: 12
				}
			}
		}
		// console.log("owlCarousel: ", $(this).hasClass('avatar-slider'), responsive)

    $(this).owlCarousel({
      loop: false,
      autoplay: false,
      margin: margin,
      nav: nav,
      navText: navText,
      dots: dots,
      autoplayHoverPause: true,
      // center: true,
      responsive: responsive,
    });
  });
});
</script>

<style scoped>
.web-pages .text-title {
	font-size: 22px;
	font-style: normal;
	font-weight: 700;
}

.web-pages .el-carousel__item {
  display: block !important;
}

.web-pages .stretchy-image {
  bottom: 0;
  right: 0;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
